import { forwardRef } from "react";
import cn from "mcn";

export const RecurringAlertIcon = forwardRef<
  SVGSVGElement,
  React.HTMLAttributes<SVGSVGElement> & {
    active?: boolean;
    size?: number;
  }
>(({ active, size = 18, className, ...props }, ref) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Icon with external label
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      ref={ref}
      {...props}
    >
      <path
        d="M1.12638 8.95396C1.10177 9.37311 1.40939 9.73511 1.81853 9.76368C2.22767 9.79226 2.57529 9.47155 2.60297 9.04922L2.61835 8.79519C2.72294 7.05507 4.11955 5.69917 5.80841 5.69917H12.3854L10.6935 7.44564C10.4043 7.74413 10.4043 8.22679 10.6935 8.5221C10.9826 8.81741 11.4502 8.82059 11.7363 8.5221L14.6895 5.47371C14.9787 5.17523 14.9787 4.69257 14.6895 4.39725L11.7394 1.34887C11.4502 1.05038 10.9826 1.05038 10.6965 1.34887C10.4105 1.64735 10.4074 2.13002 10.6965 2.42533L12.3885 4.1718H5.81148C3.34127 4.17497 1.29865 6.15643 1.14176 8.69992L1.12638 8.95396ZM16.8736 9.04922C16.8982 8.63007 16.5906 8.26807 16.1815 8.23949C15.7723 8.21091 15.4247 8.53163 15.4001 8.95396L15.3847 9.20799C15.2801 10.9481 13.8804 12.304 12.1916 12.304H5.6146L7.30653 10.5575C7.5957 10.259 7.5957 9.77639 7.30653 9.48107C7.01737 9.18576 6.54978 9.18259 6.26369 9.48107L3.31051 12.5263C3.02134 12.8248 3.02134 13.3074 3.31051 13.6027L6.26369 16.6511C6.55286 16.9496 7.02044 16.9496 7.30653 16.6511C7.59262 16.3526 7.5957 15.87 7.30653 15.5747L5.6146 13.8282H12.1916C14.6618 13.8282 16.7044 11.8467 16.8582 9.30325L16.8736 9.04922Z"
        fill="currentColor"
      />
    </svg>
  );
});
